import { render } from "./CompetitionCard.vue?vue&type=template&id=4edd7080&scoped=true"
import script from "./CompetitionCard.vue?vue&type=script&lang=js"
export * from "./CompetitionCard.vue?vue&type=script&lang=js"

import "./CompetitionCard.vue?vue&type=style&index=0&id=4edd7080&scoped=true&lang=scss"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/broome-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4edd7080"]])

export default __exports__